"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatBoostTheme = void 0;
var styles_1 = require("@mui/material/styles");
var LINE_HEIGHT = {
    0: 1,
    1: 1.2,
    2: 1.4,
    3: 1.6,
    4: 1.8,
    5: 2,
};
var LETTER_SPACING = 0;
var FONT_FAMILY = "Noto Sans JP, sans-serif";
var FONT_WEIGHT = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 700,
};
var FONT_SIZE = {
    "2xs": "10px",
    xs: "12px",
    sm: "14px",
    base: "16px",
    lg: "18px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "32px",
    "4xl": "40px",
};
var getTextPattern = function (fontSize) { return ({
    fontFamily: FONT_FAMILY,
    fontSize: FONT_SIZE[fontSize],
    lineHeight: LINE_HEIGHT["2"],
    letterSpacing: LETTER_SPACING,
}); };
exports.chatBoostTheme = (0, styles_1.createTheme)({
    fontSize: FONT_SIZE,
    palette: {
        common: {
            black: "#000",
            white: "#fff",
        },
        primary: {
            main: "#3B91D1",
            light: "#24A6F7",
            dark: "#1A67A0",
            contrastText: "#fff",
        },
        secondary: {
            main: "#39546C",
            light: "#6B83A0",
            dark: "#032136",
            contrastText: "#fff",
        },
        error: {
            main: "#EA2C24",
            light: "#FF4038",
            dark: "#9F110B",
            contrastText: "#fff",
        },
        warning: {
            main: "#FA6710",
            light: "#FF9B26",
            dark: "#642906",
            contrastText: "#fff",
        },
        info: {
            main: "#DD468F",
            light: "#FF54A9",
            dark: "#FF54A9",
            contrastText: "#fff",
        },
        success: {
            main: "#00A085",
            light: "#0AC8A8",
            dark: "#0AC8A8",
            contrastText: "#fff",
        },
        text: {
            primary: "#032136",
            secondary: "#39546C",
            // disabled: "#C0D3DF", 古いthemeの色
            disabled: "#dbe6f0",
        },
        background: {
            paper: "#fff",
            default: "#fff",
        },
        action: {
            active: "#6b83a0",
            hover: "#f5f6fa",
            selected: "#e7eff7",
            disabled: "#cad8e8",
            disabledBackground: "#e7eff7",
            focus: "#dbe6f0",
        },
        gradation: {
            main: "linear-gradient(180deg, rgba(154, 157, 166, 0) 0%, rgba(154, 157, 166, 0.3) 100%)",
        },
        neutral: {
            main: "#8DA3BE",
            light: "#DBE6F0",
        },
        tableBackground: {
            main: "#F5F6FA",
        },
        border: {
            main: "#DBE6F0",
        },
        grey: {
            50: "#f5f6fa",
            100: "#e7eff7",
            200: "#dbe6f0",
            300: "#cad8e8",
            400: "#bacadd",
            500: "#8da3be",
            600: "#6b83a0",
            700: "#39546c",
            800: "#1c374a",
            900: "#032136",
        },
        blue: {
            50: "#f5fbff",
            100: "#ebf4fa",
            200: "#dcf1fe",
            300: "#c6e6fe",
            400: "#9dc8e8",
            500: "#24a6f7",
            600: "#3b91d1",
            700: "#1a67a0",
            800: "#0e466f",
            900: "#032844",
        },
        pink: {
            50: "#fff7fb",
            100: "#fcecf4",
            200: "#fee0ef",
            300: "#ffc8e2",
            400: "#eb88b7",
            500: "#ff54a9",
            600: "#dd468f",
            700: "#af2165",
            800: "#af2165",
            900: "#34041b",
        },
        red: {
            50: "#fff6f6",
            100: "#fdeae9",
            200: "#fee0ef",
            300: "#ffbebb",
            400: "#f59591",
            500: "#ff4038",
            600: "#ea2c24",
            700: "#9f110b",
            800: "#5e120e",
            900: "#3d0300",
        },
        orange: {
            50: "#fff9f4",
            100: "#fef0e7",
            200: "#ffe4d3",
            300: "#ffd4ba",
            400: "#fdb387",
            500: "#ff9b26",
            600: "#fa6710",
            700: "#a5440a",
            800: "#642906",
            900: "#421d07",
        },
        green: {
            50: "#f1fdfc",
            100: "#ebfcf9",
            200: "#e5f5f3",
            300: "#adeae0",
            400: "#80cfc2",
            500: "#0ac8a8",
            600: "#00a085",
            700: "#0b7664",
            800: "#005043",
            900: "#022e27",
        },
        other: {
            modalBackground: "#39546c99",
            snackbarBackground: "#032136e6",
            ratingActive: "#ffe934",
            textLink: "#1f5eff",
            textLinkHover: "#003bd3",
        },
    },
    custom: {
        // disabledの時の色の定義がおかしかったため、後で修正できるようにこの定義に一旦修正。
        color: { disabledBackground: "#FAFAFA", disabledIcon: "#C0C0C0" },
    },
    typography: {
        // fontFamily: FONT_FAMILY,
        // fontWeightLight: FONT_WEIGHT.light,
        // fontWeightRegular: FONT_WEIGHT.regular,
        // fontWeightMedium: FONT_WEIGHT.medium,
        // fontWeightBold: FONT_WEIGHT.bold,
        // FIXME: 多分このallVariantsは不要。元からあったので残しているだけ。
        allVariants: {
            fontFamily: "'Noto Sans JP', 'Hiragino Sans', sans-serif",
        },
        fontSize: 20,
        h1: {
            fontWeight: 700,
            fontSize: "32px",
            lineHeight: "140%",
        },
        h2: {
            fontWeight: 700,
            fontSize: "24px",
            lineHeight: "140%",
        },
        h3: {
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "140%",
        },
        h4: {
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "140%",
        },
        h5: {
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "140%",
        },
        h6: {
            fontWeight: 700,
            fontSize: "12px",
            lineHeight: "140%",
        },
    },
    textPattern: __assign({ hint: {
            light: __assign(__assign({}, getTextPattern("2xs")), { fontWeight: FONT_WEIGHT.light, lineHeight: LINE_HEIGHT["0"] }),
            regular: __assign(__assign({}, getTextPattern("2xs")), { fontWeight: FONT_WEIGHT.regular, lineHeight: LINE_HEIGHT["0"] }),
            medium: __assign(__assign({}, getTextPattern("2xs")), { fontWeight: FONT_WEIGHT.medium, lineHeight: LINE_HEIGHT["0"] }),
            bold: __assign(__assign({}, getTextPattern("2xs")), { fontWeight: FONT_WEIGHT.bold, lineHeight: LINE_HEIGHT["0"] }),
        } }, Object.keys(FONT_SIZE).reduce(function (patterns, fontSize) {
        var _a;
        return __assign(__assign({}, patterns), (_a = {}, _a["text-".concat(fontSize)] = {
            light: __assign(__assign({}, getTextPattern(fontSize)), { fontWeight: FONT_WEIGHT.light }),
            regular: __assign(__assign({}, getTextPattern(fontSize)), { fontWeight: FONT_WEIGHT.regular }),
            medium: __assign(__assign({}, getTextPattern(fontSize)), { fontWeight: FONT_WEIGHT.medium }),
            bold: __assign(__assign({}, getTextPattern(fontSize)), { fontWeight: FONT_WEIGHT.bold }),
        }, _a));
    }, {})),
    shadows: [
        "none", // 0
        "0 2px 1px -1px #00000033, 0 1px 1px 0 #00000024, 0 1px 3px 0 #0000001f", // 1
        "0 3px 1px -2px #00000033, 0 2px 2px 0 #00000024, 0 1px 5px 0 #0000001f", // 2
        "0 3px 3px -2px #00000033, 0 3px 4px 0 #00000024, 0 1px 8px 0 #0000001f", // 3
        "0 2px 4px -1px #00000033, 0 4px 5px 0 #00000024, 0 1px 10px 0 #0000001f", // 4
        "0 3px 5px -1px #00000033, 0 5px 8px 0 #00000024, 0 1px 14px 0 #0000001f", // 5
        "0 3px 5px -1px #00000033, 0 6px 10px 0 #00000024, 0 1px 18px 0 #0000001f", // 6
        "0 4px 5px -2px #00000033, 0 7px 10px 1px #00000024, 0 2px 16px 1px #0000001f", // 7
        "0 5px 5px -3px #00000033, 0 8px 10px 1px #00000024, 0 3px 14px 2px #0000001f", // 8
        "0 5px 6px -3px #00000033, 0 9px 12px 1px #00000024, 0 3px 16px 2px #0000001f", // 9
        "0 6px 6px -3px #00000033, 0 10px 14px 1px #00000024, 0 4px 18px 3px #0000001f", // 10
        "0 6px 7px -4px #00000033, 0 11px 15px 1px #00000024, 0 4px 20px 3px #0000001f", // 11
        "0 7px 8px -4px #00000033, 0 12px 17px 2px #00000024, 0 5px 22px 4px #0000001f", // 12
        "0 7px 8px -4px #00000033, 0 13px 19px 2px #00000024, 0 5px 24px 4px #0000001f", // 13
        "0 7px 9px -4px #00000033, 0 14px 21px 2px #00000024, 0 5px 26px 4px #0000001f", // 14
        "0 8px 9px -5px #00000033, 0 15px 22px 2px #00000024, 0 6px 28px 5px #0000001f", // 15
        "0 8px 10px -5px #00000033, 0 16px 24px 2px #00000024, 0 6px 30px 5px #0000001f", // 16
        "0 8px 11px -5px #00000033, 0 17px 26px 2px #00000024, 0 6px 32px 5px #0000001f", // 17
        "0 9px 11px -5px #00000033, 0 18px 28px 2px #00000024, 0 7px 34px 6px #0000001f", // 18
        "0 9px 12px -6px #00000033, 0 19px 29px 2px #00000024, 0 7px 36px 6px #0000001f", // 19
        "0 10px 13px -6px #00000033, 0 20px 31px 3px #00000024, 0 8px 38px 7px #0000001f", // 20
        "0 10px 13px -6px #00000033, 0 21px 33px 3px #00000024, 0 8px 40px 7px #0000001f", // 21
        "0 10px 14px -6px #00000033, 0 22px 35px 3px #00000024, 0 8px 42px 7px #0000001f", // 22
        "0 11px 14px -7px #00000033, 0 23px 36px 3px #00000024, 0 9px 44px 8px #0000001f", // 23
        "0 11px 15px -7px #00000033, 0 24px 38px 3px #00000024, 0 9px 46px 8px #0000001f", // 24
    ],
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiSkeleton: {
            styleOverrides: {
                root: {
                    background: "#E7EFF7",
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    "&.Mui-error": {
                        "& fieldset": {
                            borderWidth: "2px",
                        },
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    "& .MuiTypography-root": {
                        verticalAlign: "middle",
                        lineHeight: "1.5",
                    },
                },
            },
        },
    },
});
